import { Router } from '@angular/router';
import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { DashboardListItemExpanded } from '../../../../services';
import { LIST } from '../dashboard-list.part.service';
import { getGridActions } from './get-grid-actions';
import { getGridColumns } from './get-grid-columns';


export function getGridSetup(util: UtilityService, list: LIST, datasetName: string, router: Router): GridSetup<DashboardListItemExpanded> {

	const listName = list == 'Dataset' ? datasetName : list;
	const listKey = listName.toLowerCase().split(' ').join('-');

	return {
		rowName: { singular: listName + ' Dashboard', plural: listName + ' Dashboards' },
		getRowKey: row => '' + row.dashboardId,
		stateKey: listKey + '-dashboards-list-grid',
		actions: getGridActions(router),
		buttons: [],
		columns: getGridColumns(util, list),
	}
}
